/**
 * MainloadingServe 常量配置
 */

export const AUDIT_JOB_CREATE_API_PATH = '/audit/jobs';
export const AUDIT_REQUEST_TIMEOUT = 30000;
export const AUDIT_POLL_FALLBACK_MS = 600;
export const MAX_CONCURRENT_LOAD_TASKS = 3;
export const LOAD_TIMEOUT_MS = 5000;

// 阶段二归档图片轮询重载配置
export const RELOAD_POLL_INTERVAL_MS = 5000;
export const RELOAD_MAX_POLL_ATTEMPTS = 60;
export const ENABLE_AUDIT_DEBUG_LOG = process.env.NODE_ENV !== 'production';
export const DEFAULT_AUDIT_BASE_URL = 'https://fc-imagudit-mvp-zllilfnpsu.cn-shenzhen.fcapp.run';
export const PRODUCTION_AUDIT_BASE_URL = 'https://alifun.litiskr.cn';

// 阶段三审核总时间预算（毫秒）。
// 服务端任务整体超时约为 300s，前端预算略高于服务端，确保正常终态一定先到，
// 前端只兜住服务端长期不返回终态的异常场景。
export const AUDIT_TIME_BUDGET_MS = 360000;

// 绝对轮询次数硬兜底，防止极端异常下死循环
export const AUDIT_HARD_MAX_POLL_COUNT = 500;

// 轮询间隔配置（根据图片数量自适应）
export const POLL_INTERVAL_CONFIG = {
  small: { maxCount: 10, initial: 400, min: 300, max: 800 },
  medium: { maxCount: 50, initial: 600, min: 400, max: 1200 },
  large: { maxCount: 200, initial: 1000, min: 600, max: 2000 },
  xlarge: { maxCount: Infinity, initial: 1500, min: 1000, max: 3000 }
};

// 审核状态
export const AUDIT_STATUS = {
  QUEUED: 'queued',
  RUNNING: 'running',
  PASSED: 'passed',
  REJECTED: 'rejected',
  FAILED: 'failed',
  TIMEOUT: 'timeout'
};

// 提示语文本
export const TIPS = [
  '请勿上传涉黄、涉政、暴恐等违规内容，共同维护良好的分享环境',
  '甜豆相册的绿色健康，需要你我一起守护',
  '耐心等待片刻，美好即将呈现'
];
